import {getEventId} from '@wix/wix-events-commons-statics'
import {withTranslation} from '@wix/yoshi-flow-editor'
import {isEditor, isMobile} from '../../../../../../commons/selectors/environment'
import {getEvent} from '../../../selectors/event'
import {getReservationExpiration, getReservationId} from '../../../selectors/reservation'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {DesktopCheckout as DesktopCheckoutPresentation} from './desktop-checkout'
import {DesktopCheckoutRuntimeProps} from './interfaces'

const mapRuntime = ({
  state,
  actions: {openTimeExpiredModal, cancelReservation, formPageLoaded, closeNativeModal, scrollToElement},
}: DetailsPageAppProps): DesktopCheckoutRuntimeProps => ({
  eventId: getEventId(getEvent(state)),
  reservationId: getReservationId(state),
  reservationExpiration: getReservationExpiration(state),
  isMobile: isMobile(state),
  isEditor: isEditor(state),
  formPageLoaded,
  cancelReservation,
  openTimeExpiredModal,
  closeNativeModal,
  scrollToElement,
})

export const DesktopCheckout = connect<{}, DesktopCheckoutRuntimeProps>(mapRuntime)(
  withTranslation()(DesktopCheckoutPresentation),
)
